import { object } from "yup";
import { nonEmptyRequiredString, practitioner } from "../shared.js";
import { soadAssessmentCompletionStatusSchema } from "./helpers.js";
import { exampleSRFData } from "./srf.js";
export const soadT2Part1DataSchema = object({
    practitioner: practitioner(),
    treatment: nonEmptyRequiredString.required("Please enter description of treatment or plan of treatment"),
    completionStatus: soadAssessmentCompletionStatusSchema,
});
const user = {
    name: "Dr Bob",
    email: "bob@bob.com",
    address: "123 hospital",
    postalCode: "SE5",
    isGuest: false,
    isConfirmed: true,
};
export const exampleSoadT2Data = [
    {
        data: {
            practitioner: user,
            treatment: "REASON",
            completionStatus: "completed",
        },
        context: {
            patient: { name: "John Doe", address: "123 address", postalCode: "SE4" },
            user,
            formContext: { officialReferenceId: "1233445" },
            srfData: exampleSRFData.map(({ data }) => data),
        },
    },
];
//# sourceMappingURL=soad-t2.js.map